<template>
  <div>
    <Layout :pagetitle="$t('Actions')">
      <form autocomplete="off" @submit.prevent="saveAction">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Action') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="4">
              <label>{{ $t('Campaign') }}</label>
              <campaignSelector :modelValue="campaign" @onChange="setCampaign" />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Affiliate') }}</label>
              <affiliateSelector :modelValue="affiliate" @onChange="setAffiliate" />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Sub Affiliate') }}</label>
              <subAffiliateSelector :modelValue="subAffiliate" @onChange="setSubAffiliate" />
            </b-col>
            <b-col md="4" v-if="$route.params.id">
              <label
                >{{ $t('Reward Profile') }} <i class="fa fa-info-circle text-secondary" :title="rewardProfileIn"
              /></label>
              <rewardProfileSelector :modelValue="rewardProfile" :isDisabled="true" @onChange="setRewardProfile" />
            </b-col>
          </b-row>
          <b-row>
            <b-col :md="$route.params.id ? 4 : 6">
              <label>UTM Medium</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="utmMedium" @keyup="formatUtms" />
            </b-col>
            <b-col :md="$route.params.id ? 4 : 6">
              <label>UTM Content</label>
              <b-form-input :trim="true" autocomplete="off" v-model="utmContent" @keyup="formatUtms" />
            </b-col>
            <b-col md="4" v-if="$route.params.id">
              <label>Token</label>
              <b-form-input :trim="true" autocomplete="off" disabled v-model="token" />
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              v-if="$route.params.id"
              :disabled="$store.state.isLoading"
            >
              {{ $t('Update') }}
            </button>
            <button type="submit" class="btn btn-primary m-1" :disabled="$store.state.isLoading" v-else>
              {{ $t('Create') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
      <b-modal v-model="showModal" title="Success" ok-only @ok="handleModalOk">
        <template #default>
          <div class="d-flex flex-column">
            <b-row>
              <b-col md="12" style="white-space: nowrap">
                <label>{{ $t('Name') }}:&nbsp;</label><span>{{ affiliateName }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" style="white-space: nowrap">
                <label>{{ $t('Token') }}:&nbsp;</label><span>{{ affiliateToken }}</span>
              </b-col>
            </b-row>
            <b-row>
              <div class="text-center">
                <qrcode-vue :value="urlAdvertising" :size="128" class="mb-2"></qrcode-vue>
                <p class="mb-1">
                  <a :href="urlAdvertising" target="_blank" rel="noopener noreferrer">{{ urlAdvertising }}</a>
                </p>
                <div class="d-flex justify-content-center">
                  <b-tooltip target="copy-button" placement="top" :title="$t('Copy Token')">
                    <b-button variant="primary" size="sm" class="m-1" @click="copyToken">
                      {{ $t('Copy') }}
                    </b-button>
                  </b-tooltip>
                </div>
              </div>
            </b-row>
          </div>
        </template>
      </b-modal>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import campaignSelector from '@/components/selectors/campaignSelector';
import affiliateSelector from '@/components/selectors/affiliateSelector';
import subAffiliateSelector from '@/components/selectors/subAffiliateSelector';
import rewardProfileSelector from '@/components/selectors/rewardProfileSelector';
import QrcodeVue from 'qrcode.vue';

export default {
  components: {
    Layout,
    campaignSelector,
    subAffiliateSelector,
    affiliateSelector,
    QrcodeVue,
    rewardProfileSelector
  },
  data() {
    return {
      name: '',
      token: '',
      utmMedium: '',
      utmContent: '',
      campaign: null,
      affiliate: null,
      subAffiliate: null,
      showModal: false,
      urlAdvertising: '',
      affiliateName: null,
      affiliateToken: null,
      rewardProfile: null,
      rewardProfileIn: '',
      action: null
    };
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getAction();
    }
  },
  methods: {
    formatUtms() {
      this.utmMedium = this.$utils.toLower(this.utmMedium);
      this.utmContent = this.$utils.toLower(this.utmContent);
    },
    saveAction() {
      if (this.$route.params?.id) {
        this.updateAction();
      } else {
        this.createAction();
      }
    },
    getAction() {
      const actionId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/action/${actionId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let action = res.data;

          this.name = action.name;
          this.token = action.token;
          this.utmMedium = action.utm_medium;
          this.utmContent = action.utm_content;
          this.campaign = action.id_campaign;
          this.affiliate = action.id_affiliate;
          this.subAffiliate = action.id_sub_affiliate;

          if (action?.affiliate?.reward_profile?.id) {
            this.rewardProfileIn = this.$t('Affiliate');
            this.rewardProfile = action.affiliate?.reward_profile?.id;
          } else if (action.campaign?.reward_profile?.id) {
            this.rewardProfileIn = this.$t('Campaign');
            this.rewardProfile = action.campaign?.reward_profile?.id;
          } else if (action?.campaign?.brand?.reward_profile?.id) {
            this.rewardProfileIn = this.$t('Brand');
            this.rewardProfile = action?.campaign?.brand?.reward_profile?.id;
          }
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createAction() {
      if (!this.validateAction()) return;
      let action = {
        name: this.name,
        utmMedium: this.utmMedium,
        utmContent: this.utmContent,
        idCampaign: this.campaign,
        idAffiliate: this.affiliate,
        idSubAffiliate: this.subAffiliate
      };

      this.$store.commit('SET_LOADING', true);

      this.$api
        .post('api/action', action)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.urlAdvertising = res.data[0]?.urlAdvertising;
          this.affiliateName = res.data[0]?.affiliateName;
          this.affiliateToken = res.data[0]?.affiliateToken;
          this.showModal = true;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create action error')
          });
        });
    },
    updateAction() {
      if (!this.validateAction()) return;
      let actionId = this.$route.params.id;
      let action = {
        name: this.name,
        utmMedium: this.utmMedium,
        utmContent: this.utmContent,
        idCampaign: this.campaign,
        idAffiliate: this.affiliate,
        idSubAffiliate: this.subAffiliate
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/action/${actionId}`, action)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'actionList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update action error')
          });
        });
    },
    validateAction() {
      if (!this.campaign) {
        this.$customAlert({
          msg: this.$t('Invalid campaign'),
          type: 'error'
        });
        return false;
      }

      if (!this.affiliate) {
        this.$customAlert({
          msg: this.$t('Invalid affiliate'),
          type: 'error'
        });
        return false;
      }

      if (this.$utils.hasSpecialChars(this.utmMedium)) {
        this.$customAlert({
          msg: this.$t('Não é possível usar caracteres especiais'),
          type: 'error'
        });
        return false;
      }

      if (this.$utils.hasSpecialChars(this.utmContent)) {
        this.$customAlert({
          msg: this.$t('Não é possível usar caracteres especiais'),
          type: 'error'
        });
        return false;
      }
      return true;
    },
    setCampaign(campaign = null) {
      this.campaign = campaign;
    },
    setAffiliate(affiliate = null) {
      this.affiliate = affiliate;
    },
    setSubAffiliate(subAffiliate = null) {
      this.subAffiliate = subAffiliate;
    },
    setRewardProfile(rewardProfile = null) {
      this.rewardProfile = rewardProfile;
    },
    handleModalOk() {
      this.showModal = false;
      this.$router.push({
        name: 'actionList'
      });
    },
    copyToken() {
      const copyText = `Nome: ${this.affiliateName}\nToken: ${this.affiliateToken} \nLink: ${this.urlAdvertising}`;
      navigator.clipboard
        .writeText(copyText)
        .then(() => {
          // A cópia do token foi bem-sucedida
          console.log('Token copied to clipboard!');
        })
        .catch((error) => {
          // Ocorreu um erro ao copiar o token
          console.error('Failed to copy token:', error);
        });
    }
  }
};
</script>
